import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaEnestas2025 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251125-Poliza-Mtto-Fortinet-Enestas-Netjer.pdf`;
  /*const pdfUrl = "/pdf/251125-Poliza-Mtto-Fortinet-Enestas-Netjer.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2025</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaEnestas2025;
